import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignGroupActionPanel } from '../types';
import { useGlobalDesignStyles } from '../common/abstractStyles';
import { TextControls } from './components/TextControls';
import { ControlsServiceProvider } from '../../automaticPanel/panelsService/ControlsServiceContext';
import { GD_WDS_EXPERIMENT } from '../experiments';
import { useTranslation } from '../..';
import { GLOBAL_DESIGN_TRANSLATION_KEYS } from '../constants';
import { resolveEditorComponent } from '../resolveEditorComponent';
import { EditorSubType } from '@wix/editor-platform-sdk-types';

const ResolvedTextControls = resolveEditorComponent({
  default: () => import('./components/TextControlsWDS'),
  overrides: {
    [EditorSubType.Studio2]: () => import('./components/TextControlsStudio2'),
  },
});

const TextStyles: GlobalDesignGroupActionPanel = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);
  const [t] = useTranslation();

  const { values, updateStyles, isLoading, error, sdkClient } =
    useGlobalDesignStyles(props.host, 'textStyles', props.componentsAPI, {
      shouldRefetchOnUpdate: false,
      withVariablesResolution: isWDS,
    });

  if (isLoading || !values) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOADING)}</div>;
  }

  if (error) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOAD_ERROR)}</div>;
  }

  if (isWDS) {
    return (
      <ResolvedTextControls
        values={values}
        updateStyles={updateStyles}
        sdkClient={sdkClient}
        metadata={props.group.metadata}
        componentsAPI={props.componentsAPI}
      />
    );
  }

  return (
    <ControlsServiceProvider host={props.host}>
      <TextControls
        values={values}
        updateStyles={updateStyles}
        componentsAPI={props.componentsAPI}
        metadata={props.group.metadata}
      />
    </ControlsServiceProvider>
  );
};

export default TextStyles;
